import { CreateReportInput, ReportRequest, TipoRelatorio } from '../interface';
import {
  getDownloadUrl as httpGetDownloadUrl,
  getReportById as httpGetReportById,
  listReports as httpListReports,
  requestReport as httpRequestReport,
  RequestReportError,
} from './reportsHttpClient';

export { RequestReportError };

export function requestReport(
  input: CreateReportInput
): Promise<ReportRequest> {
  return httpRequestReport(input);
}

export function listReports(
  tipoRelatorio?: TipoRelatorio
): Promise<ReportRequest[]> {
  return httpListReports(tipoRelatorio);
}

export function getReportById(id: string): Promise<ReportRequest | null> {
  return httpGetReportById(id);
}

export function getDownloadUrl(id: string): Promise<string | null> {
  return httpGetDownloadUrl(id);
}
